import { Component, Input, OnInit } from '@angular/core';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import {
  ParkerRegistrationDTO,
  ParkerRegistrationClient,
  ParkerRegistrationOffense,
  ParkerRegistrationType,
  ZoneDTO,
  ParkerRegistrationWithParkerInfoDTO,
  ParkingSubscriptionLimitedDTO,
  ParkingSubscriptionType,
  ParkingRangerCheckClient} from 'src/app/base/models/models.swagger.generated';
import { ParkerRegistrationDataType } from 'src/app/base/models/parker-registration-data-type.enum';
import { ParkerRegistrationDetailsHelper } from '../parker-registration-details.helper';
import { ParkerRegistrationDetailOffenseComponent } from '../parker-registration-detail-offense/parker-registration-detail-offense.component';
import { ParkerRegistrationDetailParkerDetailsComponent } from '../parker-registration-detail-parker-details/parker-registration-detail-parker-details.component';
import { AsyncImageComponent } from 'src/app/base/shared/async-image/async-image.component';

@Component({
    selector: 'app-parker-registration-raw-detail',
    templateUrl: './parker-registration-raw-detail.component.html',
    styleUrls: ['./parker-registration-raw-detail.component.scss'],
    imports: [ParkerRegistrationDetailParkerDetailsComponent, ParkerRegistrationDetailOffenseComponent, TranslateModule, AsyncImageComponent]
})
export class ParkerRegistrationRawDetailComponent implements OnInit {

  @Input() public data: ParkerRegistrationDTO;
  @Input() public zones: ZoneDTO[];

  public registration: ParkerRegistrationWithParkerInfoDTO = null;

  public ParkerRegistrationType = ParkerRegistrationType;
  public ParkerRegistrationOffense = ParkerRegistrationOffense;
  public ParkerRegistrationDataType = ParkerRegistrationDataType;

  constructor(private translate: TranslateService,
    private parkingRangerCheckClient: ParkingRangerCheckClient,
    private parkerRegistrationClient: ParkerRegistrationClient) {
  }

  public ngOnInit(): void {
    this.parkerRegistrationClient.getExtendedRegistration(this.data.id)
      .subscribe(registration => {
        this.registration = registration;
      });

    const zone = this.zones.find(z => z.id === this.data.registeredZoneId);
  }

  public getImageRequest(id: number, imageId: string): any {
    return this.parkingRangerCheckClient.getRegistrationImage(id, imageId);
  }

  public getZoneById(id: number): ZoneDTO {
    return this.zones.find(z => z.id === id);
  }

  public getRegisteredByText(registration: ParkerRegistrationDTO): string {
    return ParkerRegistrationDetailsHelper.getRegisteredByText(registration, this.translate);
  }

  public getSubscriptionType(subscription: ParkingSubscriptionLimitedDTO): string {
    if (!subscription) {
      return null;
    }
    return 'i18n.domain.parker-registration.ParkingSubscriptionType.' + ParkingSubscriptionType[subscription.type];
  }
}
